<template>
  <div>
    <div>
      <div>
        <InputSearch class="mb-3" @clickAdvancedSearch="showSearch = true" @clickSearch="onSearch"
          @clearSearch="clearSearch" :search="search" :isSearch="isSearch"
          :placeholder="'ค้นหา รหัสสมาชิก, ชื่อ - นามสกุล, อีเมล, เบอร์, สถาบัน'"
          :clearAdvancedSearch="clearAdvancedSearch" showClearAdvancedSearch showAdvancedSearch />
        <v-layout row wrap dense class="mb-3">
          <v-flex xs6 style="display: flex; align-items: center">
            <!-- <div class="headline primary--text bold7 fs-24">ข้อมูลสมาชิก</div> -->
            <Typography h2 bold label="ข้อมูลสมาชิก" />
          </v-flex>
          <v-flex xs6 style="display: flex; align-items: flex-end; justify-content: flex-end">
            <div class="text-xs-right" style="display: flex; align-items: flex-end">
              <!-- <v-btn
                @click="showSearch = true"
                small
                :style="`color: ${$vuetify.theme.primary};  text-transform: capitalize;position:relative;`"
                :color="`color: ${$vuetify.theme.primary}`"
                outline
                ><i class="fas fa-search mr-1"></i>{{ $t('Search') }}
                <div v-if="isSearching" style="position: absolute; right: -28px; top: -26px">
                  <v-btn @click.stop="clearSearch" dark small icon color="red">
                    <v-icon small>close</v-icon>
                  </v-btn>
                </div>
              </v-btn> -->
              <!-- <img src="/static/img/tooltip.png" style="width: 40px;height: 30px;" alt /> -->

              <v-btn variant="outlined" v-tooltip="'สมัครสมาชิก'" v-if="this.$store.state.privilege.role === 'agency'"
              @click="modalAddMember = true" :loading="loading"
                color="#BECCDB" style="padding: 10px !important">
                สมัครสมาชิก
              </v-btn>
              <v-btn variant="outlined" v-tooltip="'ส่งออกข้อมูล'" @click="modalExport = true" :loading="loading" icon
                color="#BECCDB" style="border-radius: 50% !important">
                <!-- <i class="fa fa-download" aria-hidden="true"></i> -->
                <img src="/static/img/exportfilter.png" alt class="responsive-img" style="height: 16px" />
              </v-btn>
              <exportxlsx ref="exbtn" v-model="xlsxMember" style="display: none"></exportxlsx>
              <v-btn variant="outlined" v-tooltip="'เลือกคอลัมน์'" icon :loading="loading"
                :color="drawer ? '#0C2F53' : '#BECCDB'" @click.stop="drawer = !drawer"
                style="border-radius: 50% !important">
                <img :src="`/static/img/${drawer ? 'filterColumnWhite.png' : 'filterColumnBlack.png'}`" alt
                  class="responsive-img" style="height: 20px" />
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </div>
      <!-- <div class="text-xs-right">
        <v-btn @click="exportData" :loading="loading" color="grey" outline>
          <i class="fas fa-file-export"></i>
          &nbsp;
          {{ $t('export') }}&nbsp;
        </v-btn>
        <exportxlsx ref="exbtn" v-model="xlsxMember" style="display: none"></exportxlsx>
        <v-select
          style="margin: 1.5rem 0"
          v-model="showColumn"
          :items="column"
          label="เลือกดูข้อมูลเฉพาะ"
          multiple
          dense
          chips
          persistent-hint
          hide-details
        ></v-select>
      </div> -->
      <v-navigation-drawer v-model="drawer" right fixed temporary style="top: 200px; padding: 20px">
        <v-list density="compact" nav>
          <v-flex xs12 style="display: flex; align-items: center; justify-content: space-between">
            <!-- <div class="color-darkBlue bold7 fs-20">เลือกคอลัมน์</div> -->
            <Typography h3 bold label="เลือกคอลัมน์" />
            <v-icon @click.stop="drawer = false">close</v-icon>
          </v-flex>
          <div style="display: flex">
            <v-flex xs10 class="mb-2 mt-2">
              <div style="width: 100%; display: flex; align-items: center" class="form-group has-search">
                <div style="width: 100%; display: flex; justify-content: flex-end; border-right: 0px"
                  class="form-control">
                  <input @change="changeSearchColumn" type="search" class="depainput rsu mb-0" placeholder="Search"
                    name="search" v-model="searchColumn" style="border-radius: 0px; border-right: 0px" />
                </div>
              </div>
            </v-flex>
            <v-flex xs2 class="mb-2 mt-2">
              <div class="pointer" style="
                          border: 1px solid #cfcfcf;
                          height: 100%;
                          display: flex;
                          justify-content: center;
                          align-items: center;
                          border-left: 0px;
                          border-right: 0px;
                          border-top-color: initial !important;
                          border-bottom-color: initial !important;
                        ">
                <span class="fa fa-times-circle form-control-feedback pointer" style="color: #00000040"
                  @click="clearSearchColumn"></span>
              </div>
            </v-flex>
            <v-flex xs2 class="mb-2 mt-2">
              <div class="pointer" style="
                          border: 1px solid #cfcfcf;
                          height: 100%;
                          display: flex;
                          justify-content: center;
                          align-items: center;
                          border-top-color: initial !important;
                          border-bottom-color: initial !important;
                        ">
                <span @click="changeSearchColumn" class="fa fa-search form-control-feedback"
                  style="color: #bdbdbd"></span>
              </div>
            </v-flex>
          </div>
          <div style="overflow: auto; height: 380px">
            <div class="mt-2" style="display: flex" v-for="item in this.column" @click="clickShowColumn(item)"
              :key="item">
              <v-checkbox color="#0C2F53" style="display: flex; flex: none !important" v-model="showColumn.includes(item)"
                hide-details dense>
              </v-checkbox>
              <!-- <div class="color-darkBlue">
                {{ item }}
              </div> -->
              <Typography h5 :label="item" />
            </div>
          </div>
        </v-list>
      </v-navigation-drawer>
      <v-layout class="my-5" justify-center v-if="loading">
        <v-progress-circular :size="100" :width="10" indeterminate color="primary"></v-progress-circular>
      </v-layout>
      <div v-else>
        <v-data-table expand hide-actions :loading="loading" :headers="headers" :items="desserts" select-all
          item-key="name" class="fixTable">
          <template v-slot:headers="props">
            <tr style="background-color: #152d53; color: white">
              <th style="background-color: #152d53; color: yellow" v-for="header in props.headers"
                v-show="showColumn.includes(header.text) || header.text == ''" :key="header.text">
                <div v-show="showColumn.includes(header.text)" :style="`text-align:${header.align}`">
                  {{ header.text }}
                </div>
              </th>
            </tr>
          </template>
          <template v-slot:items="props">
            <tr style="cursor: pointer" @click="showEdit(props.item), (isEdit = false)">
              <td v-show="showColumn.includes('รหัสสมาชิก')" class="text-xs-left" style="position: relative">
                <!-- <div style="white-space: nowrap" class="fs-16">
                  {{ props.item.memberid }}
                </div> -->
                <Typography h5 :label="props.item.memberid" />
                <div v-if="
                  props.item.admin ||
                  firstUserId.includes(parseInt(props.item.memberid).toString())
                " style="position: absolute; right: 0px; top: 2px; display: flex">
                  <div v-if="props.item.admin" class="fs-16" style="
                              padding: 1px 3px;
                              background-color: red;
                              color: white;
                              font-size: 9px;
                              border-radius: 95px;
                              font-weight: 600;
                            ">
                    ADMIN
                  </div>
                  <div v-if="firstUserId.includes(parseInt(props.item.memberid).toString())" class="fs-16" style="
                              padding: 1px 3px;
                              margin-left: 2px;
                              background-color: green;
                              color: white;
                              font-size: 9px;
                              border-radius: 95px;
                              font-weight: 600;
                            ">
                    APPROVER
                  </div>
                </div>
              </td>

              <td v-show="showColumn.includes('ชื่อ - นามสกุล')" class="text-xs-left">
                <!-- {{ props.item.name ? props.item.name : '-' }} -->
                <Typography h5 style="width: 200px" :label="props.item.name ? props.item.name : '-'" />
              </td>
              <td v-show="showColumn.includes('สถานะ DP')" class="text-xs-center">
                <!-- <v-btn
                style="border-radius: 20px !important;"
                class="color-gradientBlue color-white none-shadow v-btn-ml"
                @click="$emit('clickAdvancedSearch')"
                > -->
                <v-btn v-if="props.item.dptype === 'DP'" @click.stop="statusDPEdit(props.item)"
                  class="color-gradientBlue color-white none-shadow v-btnl"
                  style="border-radius: 50px !important; height: 30px">
                  {{ props.item.dptype ? props.item.dptype : '-' }}
                </v-btn>
                <v-btn v-else-if="props.item.dptype === 'Non-DP'" @click.stop="statusDPEdit(props.item)" outline
                  color="#0C2F53" style="
                            border-radius: 50px !important;
                            height: 30px;
                            background-color: #ffffff !important;
                          ">
                  {{ props.item.dptype ? props.item.dptype : '-' }}
                </v-btn>
                <v-btn v-else @click.stop="statusDPEdit(props.item)" color="#EEEEEE"
                  style="border-radius: 50px !important; height: 30px; box-shadow: none">
                  {{ props.item.dptype ? props.item.dptype : '-' }}
                </v-btn>
              </td>
              <!-- <td v-show="showColumn.includes('PIC')" class="text-xs-center py-1">
                <v-avatar>
                  <v-img v-if="props.item.profile_pic" :src="props.item.profile_pic"></v-img>
                  <span v-else>-</span>
                </v-avatar>
              </td> -->
              <td v-show="showColumn.includes('อีเมล')" class="text-xs-left">
                {{ props.item.email ? props.item.email : '-' }}
              </td>
              <td v-show="showColumn.includes('เบอร์')" class="text-xs-left">
                {{ props.item.phone_number ? props.item.phone_number : '-' }}
              </td>
              <!-- <td class="text-xs-center">{{ props.item.membertype }}</td> -->

              <!-- <td class="text-xs-left">{{ props.item.id_card ? props.item.id_card : '-' }}</td> -->

              <td v-show="showColumn.includes('สถาบัน')" class="text-xs-left">
                {{ props.item.institute_name ? props.item.institute_name : '-' }}
              </td>
              <td v-show="showColumn.includes('แท็ก')" class="text-xs-left">
                {{ props.item.tags ? props.item.tags : '-' }}
              </td>
              <td v-show="showColumn.includes('ประเภทสมาชิก')" class="text-xs-left">
                <!-- {{ props.item.membertype ? props.item.membertype : '-' }} -->
                <Typography h5 style="width: 200px" :label="props.item.membertype ? props.item.membertype : '-'" />
              </td>
              <td v-show="showColumn.includes('สถานะ Odoo')" class="text-xs-left">
                {{ props.item.odooinfo ? props.item.odooinfo[1].plan_status : '-' }}
              </td>
              <td v-show="showColumn.includes('รวม Odoo')" class="text-xs-left">
                {{
                  props.item.odooinfo && props.item.odooinfo.total ? props.item.odooinfo.total : '-'
                }}
              </td>
              <td v-show="showColumn.includes('ข้อมูล Odoo')" class="text-xs-left">
                <!-- <v-btn
                  depressed
                  small
                  style="text-transform: none"
                  color="primary"
                  @click.stop="showOdooInfo(props.item.odooinfo, props.item.memberid)"
                  >Odoo info</v-btn
                > -->
                <div style="text-decoration: underline; width: 50px; color: #26588b"
                  @click.stop="showOdooInfo(props.item.odooinfo, props.item.memberid)">
                  ดูข้อมูล
                </div>
              </td>
              <td v-show="showColumn.includes('สถานะ')" class="text-xs-left">
                <div small :style="{
                  color: statusColor(props.item.status),
                  background: 'none',
                  width: '110px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                }">
                  <span class="fs-20">&#8226;</span>{{ statusLabel(props.item.status) }}
                </div>
              </td>
              <td v-show="showColumn.includes('SME ONE ID')" class="text-xs-left">
                <v-btn v-if="![true].includes(props.item.sme)" 
                 @click.stop="verifySME(props.item)" outline style="
                            border-radius: 50px !important;
                            height: 30px;
                            color: #0c2f53 !important;
                            background-color: #ffffff !important;
                          " :style="{ opacity: ['unconfirmed'].includes(props.item.status) ? '40%' : '100%' }">
                  {{ statusSME(props.item.sme) }}
                </v-btn>
                <v-btn v-else :disabled="[true].includes(props.item.sme)"
                 @click.stop="verifySME(props.item)" outline style="
                            border-radius: 50px !important;
                            height: 30px;
                            color: #67ad5b !important;
                            background-color: #ffffff !important;
                          ">
                  {{ statusSME(props.item.sme) }}
                </v-btn>
              </td>
              <td v-show="showColumn.includes('DBD')" class="text-xs-left">
                <v-btn v-if="props.item.verification == 'มี Tax ID' && ![true].includes(props.item.id_card)" 
                 @click.stop="openModalDBD(props.item)" outline style="
                            border-radius: 50px !important;
                            height: 30px;
                            color: #0c2f53 !important;
                            background-color: #ffffff !important;
                          " :style="{ opacity: ['unconfirmed'].includes(props.item.status) ? '40%' : '100%' }">
                  DBD
                </v-btn>
                <v-btn v-else disabled outline style="
                            border-radius: 50px !important;
                            height: 30px;
                            background-color: #ffffff !important;
                          ">
                  DBD
                </v-btn>
              </td>
              <td @click.stop="" class="text-xs-center">
                <v-btn :disabled="['pending'].includes(props.item.status)"
                  v-if="!['rejected', 'unconfirmed'].includes(props.item.status)" @click.stop="rejectMember(props.item)"
                  outline style="
                            border-radius: 50px !important;
                            height: 30px;
                            color: red !important;
                            background-color: #ffffff !important;
                          " :style="{ opacity: ['pending'].includes(props.item.status) ? '40%' : '100%' }">
                  ปฏิเสธ
                </v-btn>
                <v-btn v-else :disabled="['unconfirmed'].includes(props.item.status)"
                  @click.stop="verifyMember(props.item)" outline style="
                            border-radius: 50px !important;
                            height: 30px;
                            color: #67ad5b !important;
                            background-color: #ffffff !important;
                          " :style="{ opacity: ['unconfirmed'].includes(props.item.status) ? '40%' : '100%' }">
                  ยืนยันตัวตน
                </v-btn>
              </td>
              <td v-show="showColumn.includes('สถานะการจ่ายเงิน')" class="text-xs-left" @click.stop="">
                <!-- {{ props.item.paymentstatus }} -->
                <v-btn v-if="props.item.paymentstatus === 'จ่ายเงินแล้ว'"
                  :disabled="['false'].includes($localStorage.get('can_change_payment_status'))"
                  @click.stop="statusPaymentEdit(props.item.memberid, 'ยังไม่จ่ายเงิน')"
                  class="color-gradientBlue color-white none-shadow v-btnl"
                  style="border-radius: 50px !important; height: 30px; color: white !important">
                  {{ props.item.paymentstatus ? props.item.paymentstatus : '-' }}
                </v-btn>
                <v-btn v-else :disabled="['false'].includes($localStorage.get('can_change_payment_status'))"
                  @click.stop="statusPaymentEdit(props.item.memberid, 'จ่ายเงินแล้ว')" outline color="#0C2F53" style="
                            border-radius: 50px !important;
                            height: 30px;
                            background-color: #ffffff !important;
                          ">
                  {{ 'ยังไม่จ่ายเงิน' }}
                </v-btn>
              </td>
              <td v-show="showColumn.includes('สลิป')" class="text-xs-center">
                <div v-if="props.item.payment_transaction_id"
                  style="text-decoration: underline; width: 55px; color: #26588b"
                  @click.stop="checkPaymentTransaction(props.item.payment_transaction_id)">
                  ดูสลิป
                </div>
                <div v-else>-</div>
              </td>
              <td v-show="showColumn.includes('ประวัติ')" @click.stop="" class="text-xs-left">
                <div style="text-decoration: underline; width: 55px; color: #26588b" @click.stop="
                  depamemberlog(props.item.memberid)
                                                                                            showHistory = true
                                                                                          ">
                  ดูประวัติ
                </div>
              </td>
              <td v-show="showColumn.includes('ข้อมูลร้านค้า')" @click.stop="" class="text-xs-left">
                <a target="_blank" v-if="props.item.techproviderid !== null" style="
                            text-decoration: underline;
                            color: #26588b;
                            background-color: unset !important;
                            font-size: 16px;
                            padding: 0px !important;
                            line-height: 1.5 !important;
                            height: 25px !important;
                          " :href="`${techhuntUrl}aboutshop?id=${props.item.techproviderid}`" class="btn text-xs-left">
                  ไปยังร้านค้า
                </a>
                <div v-else>-</div>
              </td>
              <td @click.stop="">
                <v-btn @click.stop="deleteMember(props.item)" outline color="red" style="
                            border-radius: 50px !important;
                            height: 30px;
                            background-color: #ffffff !important;
                          ">
                  ยกเลิกการสมัคร
                </v-btn>
              </td>
              <td style="white-space: nowrap" @click.stop="">
                <TooltipTable :datas="props" @modalEdit="showEdit(props.item), (isEdit = true)" showChangePassword
                  showChat showChatLink memberInfo
                  @store="store(props.item.email ? props.item.email : props.item.phone_number)"></TooltipTable>
                <!-- <v-btn @click="showModalEdit(props.item)" icon outline>
                  <i :color="$vuetify.theme.primary" class="fas fa-pencil-alt"></i>
                </v-btn>
                <v-btn @click="clickDelete(props.item)" icon outline>
                  <v-icon>mdi-delete</v-icon>
                </v-btn> -->
              </td>
            </tr>
          </template>
        </v-data-table>
        <!-- modalAddMember สมัครสมาชิก -->
        <v-dialog v-model="modalAddMember" persistent width="600px">
          <form>
            <v-card style="border-radius: 10px; padding: 16px;">
              <div class="pa-3">
                <div style="display: flex; justify-content: space-between">
                  <div></div>
                  <Typography h2 bold label="สมัครสมาชิก" />
                  <v-icon style="display: flex; align-items: center" @click="closeModalAddMember">close</v-icon>
                </div>
              </div>

              <v-radio-group v-model="memberAddUser" row>
                <v-radio :key="'อีเมล'" :label="'อีเมล'" :value="'email'" color="primary"></v-radio>
                <v-radio :key="'เบอร์โทรศัพท์'" :label="'เบอร์โทรศัพท์'" :value="'phone'" color="primary"></v-radio>
              </v-radio-group>
              <div class="mb-4" v-if="memberAddUser == 'email'">
                <Typography class="pr-3" h5 label="อีเมล" />
                <div style="width: 100%" class="form-control">
                  <input name="อีเมล" placeholder="กรอกอีเมล" v-model="memberAdd.email" type="email"
                    class="depainput rsu mb-0" v-validate="{
                    }" />
                  <span class="text-error" v-if="errors.has('อีเมล')">{{ errors.first('อีเมล') }}</span>
                </div>
              </div>

              <div class="mb-4" v-if="memberAddUser == 'phone'">
                <Typography class="pr-3" h5 label="เบอร์โทรศัพท์" />
                <div style="width: 100%" class="form-control">
                  <input name="เบอร์โทรศัพท์" placeholder="กรอกเบอร์โทรศัพท์" v-model="memberAdd.phone" type="number"
                    class="depainput rsu mb-0" v-validate="{
                      regex: /^[+]{1}[1-9]{1}[0-9]{0,2}[1-9]{1}[0-9]{7,8}$|^[0-9]{3,4}$/,
                    }" />
                  <span class="text-error" v-if="errors.has('เบอร์โทรศัพท์')">{{ errors.first('เบอร์โทรศัพท์') }}</span>
                </div>
              </div>


              <div class="mb-2">
                <Typography class="pr-3" h5 label="รหัสผ่าน" />
                <div style="width: 100%" class="form-control">
                  <div
                    style="display: flex;flex-direction: row;justify-content: space-between;align-items: center;border: 1px solid #2c2c2c; border-radius:6px;padding: 4px 8px;">

                    <input name="รหัสผ่าน" placeholder="กรอกรหัสผ่าน" v-model="memberAdd.password" :type="typeInput"
                      class="depainput rsu mb-0" style="border: 0px !important;" v-validate="{
                        required: true,
                        regex: /^(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%&0-9]).{8,}$/,
                      }" />
                    <img @click="toggleShow" :src="showPassword ? imgShowPass : imgHidePass" width="25" height="25" />

                  </div>
                  <span class="text-error" v-if="errors.has('รหัสผ่าน')">{{ errors.first('รหัสผ่าน') }}</span>
                </div>
              </div>
              <Typography class="pr-3" h5 label="- ตัวอักษรภาษาอังกฤษพิมพ์ใหญ่อย่างน้อย 1 ตัว" />
              <Typography class="pr-3" h5 label="- ตัวอักษรภาษาอังกฤษพิมพ์เล็กอย่างน้อย 1 ตัว" />
              <Typography class="pr-3" h5 label="- อักขระพิเศษ (!,@,#,$,%,&) หรือ ตัวเลขอย่างน้อย 1 ตัว" />
              <Typography class="mb-4" h5 label="- ความยาวอย่างน้อย 8 ตัวอักษร" />

              <div class="mb-4">
                <Typography class="pr-3" h5 label="ยืนยันรหัสผ่าน" />
                <div style="width: 100%" class="form-control">
                  <div
                    style="display: flex;flex-direction: row;justify-content: space-between;align-items: center;border: 1px solid #2c2c2c; border-radius:6px;padding: 4px 8px;">

                    <input name="ยืนยันรหัสผ่าน" placeholder="กรอกรหัสผ่าน" v-model="memberAdd.confirmPassword"
                      :type="typeInputConfirmPassword" style="border: 0px !important;" class="depainput rsu mb-0"
                      v-validate="{
                        required: true,
                        regex: /^(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%&0-9]).{8,}$/,
                      }" />

                    <img @click="toggleShowConfirm" :src="showConfirmPassword ? imgShowPass : imgHidePass" width="25"
                      height="25" />

                  </div>
                  <span class="text-error" v-if="errors.has('ยืนยันรหัสผ่าน')">{{ errors.first('ยืนยันรหัสผ่าน') }}</span>
                </div>
              </div>

              <v-select
                v-model="memberAdd.agencyId"
                placeholder="เลือกประเภท"
                :items="this.$store.state.privilege.agency"
                item-text="agencyname"
                item-value="id"
                hide-details
                dense
                outline
                append-icon="mdi-chevron-down"
                class="button-select member"
              >
              </v-select>
              <Typography h2 bold :label="memberAdd.tel"> </Typography>
              <div style="display: flex ;justify-content: center;">
                <v-btn variant="outlined" v-tooltip="'สมัครสมาชิก'" @click="submitMemberAdd()" color="#BECCDB"
                  style="padding: 10px !important; justify-content: center;">
                  ยืนยัน
                </v-btn>
              </div>
            </v-card>
          </form>
        </v-dialog>

        <v-dialog v-model="modalVerifyMemberType" persistent width="600px">
          <form>
            <v-card style="border-radius: 10px; padding: 16px;" class="member-select">
              <div class="pa-3">
                <div style="display: flex; justify-content: space-between">
                  <div></div>
                  <Typography h2 bold label="ยืนยันตัวตน" />
                  <v-icon style="display: flex; align-items: center" @click="closeModalVerifyMemberType">close</v-icon>
                </div>
              </div>

              <v-select
                v-model="membertypeVerify"
                placeholder="เลือกประเภท"
                :items="membertype"
                item-text="type"
                item-value="typeid"
                hide-details
                dense
                outline
                append-icon="mdi-chevron-down"
                class="button-select member"
              >
              </v-select>
              <div style="display: flex ;justify-content: center;">

              <v-btn variant="outlined" v-tooltip="'สมัครสมาชิก'" @click="submitVerifyMemberType()" color="#BECCDB"
                  style="padding: 10px !important; justify-content: center;margin-top: 24px;">
                  ยืนยัน
                </v-btn>
                </div>

            </v-card>
          </form>
        </v-dialog>

        <v-dialog v-model="modalVerifyMember" persistent width="600px">
          <form>
            <v-card style="border-radius: 10px; padding: 16px;">
              <div class="pa-3">
                <div style="display: flex; justify-content: space-between">
                  <div></div>
                  <Typography h2 bold label="กรอกข้อมูลยืนยันตัวตน" />
                  <v-icon style="display: flex; align-items: center" @click="modalVerifyMember = false">close</v-icon>
                </div>
              </div>

                <div v-if="datatypeVerify.verification == 'บุคคลธรรมดา' || verification == 'เกษตรกร'">
                  <div class="mb-4">
                    <Typography class="pr-3" h5 label="ชื่อ" />
                    <div style="width: 100%" class="form-control">
                      <input name="ชื่อ" placeholder="กรอกชื่อ" v-model="valueIndividual.name" type="text"
                        class="depainput rsu mb-0" v-validate="{
                        }" />
                      <span class="text-error" v-if="errors.has('ชื่อ')">{{ errors.first('ชื่อ') }}</span>
                    </div>
                  </div>

                  <!-- <div class="mb-4">
                    <Typography class="pr-3" h5 label="นามสกุล" />
                    <div style="width: 100%" class="form-control">
                      <input name="นามสกุล" placeholder="กรอกนามสกุล" v-model="valueIndividual.surname" type="text"
                        class="depainput rsu mb-0" v-validate="{
                        }" />
                      <span class="text-error" v-if="errors.has('นามสกุล')">{{ errors.first('นามสกุล') }}</span>
                    </div>
                  </div> -->

                  <div class="mb-4">
                    <Typography class="pr-3" h5 label="วันเดือนปีเกิด" />
                    <v-radio-group
                      class="mt-0 bold5 pt-0"
                      v-model="valueIndividual.birthdayRadio"
                    >
                      <div v-for="(item, key) in itemRadio" :key="key">
                        <v-radio
                          :label="item.label"
                          :value="item.value"
                          :class="item.class"
                        ></v-radio>
                      </div>
                    </v-radio-group>

                    <div class="mb-4 date-picker-style" v-if="valueIndividual.birthdayRadio == 'มีวันเดือนปีเกิดครบถ้วน' " >
                      <date-picker
                          :append-to-body="false"
                          :clearable="false"
                          :editable="false"
                          name="End Date show"
                          v-model="valueIndividual.dob"
                          valueType="date"
                          format="DD/MM/YYYY"
                          placeholder="เลือกวันที่เริ่ม"
                          confirm
                        >
                          <template v-slot:footer="{ emit }">
                            <div style="text-align: left">
                              <button class="mx-btn mx-btn-text" @click="emit(new Date())">
                                Today
                              </button>
                            </div>
                          </template>
                        </date-picker>
                    </div>
                    <div class="mb-4 date-picker-style" v-if="valueIndividual.birthdayRadio == 'มีเฉพาะเดือนและปีเกิด' " >
                      <date-picker
                          :append-to-body="false"
                          :clearable="false"
                          :editable="false"
                          name="End Date show"
                          v-model="valueIndividual.dob"
                          valueType="date"
                          format="MM/YYYY"
                          placeholder="เลือกวันที่เริ่ม"
                          confirm
                          type="month"
                        >
                          <template v-slot:footer="{ emit }">
                            <div style="text-align: left">
                              <button class="mx-btn mx-btn-text" @click="emit(new Date())">
                                Today
                              </button>
                            </div>
                          </template>
                        </date-picker>
                    </div>
                    <div class="mb-4 date-picker-style" v-if="valueIndividual.birthdayRadio == 'มีเฉพาะปีเกิด' ">
                      <date-picker
                          :append-to-body="false"
                          :clearable="false"
                          :editable="false"
                          name="End Date show"
                          v-model="valueIndividual.dob"
                          valueType="date"
                          format="YYYY"
                          placeholder="เลือกวันที่เริ่ม"
                          confirm
                          type="year"
                        >
                          <template v-slot:footer="{ emit }">
                            <div style="text-align: left">
                              <button class="mx-btn mx-btn-text" @click="emit(new Date())">
                                Today
                              </button>
                            </div>
                          </template>
                        </date-picker>
                    </div>
                  </div>

                  <div class="mb-4">
                    <Typography class="pr-3" h5 label="เลขบัตรประชาชน" />
                    <div style="width: 100%" class="form-control">
                      <input name="เลขบัตรประชาชน" placeholder="x-xxxx-xxxxx-xx-x" v-model="valueIndividual.id_card" type="text"
                        class="depainput rsu mb-0" v-validate="{
                        }" />
                      <span class="text-error" v-if="errors.has('เลขบัตรประชาชน')">{{ errors.first('เลขบัตรประชาชน') }}</span>
                    </div>
                  </div>

                  <div class="mb-4">
                    <Typography class="pr-3" h5 label="เลขหลังบัตรประชาชน (พิมพ์ตัวอักษร 2 ตัว ตามด้วยเลข 10 หลัก)" />
                    <div style="width: 100%" class="form-control">
                      <input name="เลขหลังบัตรประชาชน" placeholder="AA0-0000000-00" v-model="valueIndividual.laser_no" type="text"
                        class="depainput rsu mb-0" v-validate="{
                        }" />
                      <span class="text-error" v-if="errors.has('เลขหลังบัตรประชาชน')">{{ errors.first('เลขหลังบัตรประชาชน') }}</span>
                    </div>
                  </div>

                  <div class="mb-4">
                      <Typography class="pr-3" h5 label="อัปโหลดเอกสาร ( ไฟล์  image ,doc, docx,pdf เท่านั้น )" />
                      <uploadalltype
                        v-model="valueIndividual.document"
                        v-validate
                        :multiple="true"
                        :showOnlyButton="true"
                      ></uploadalltype>
                  </div>
                </div>

                <div v-else-if="datatypeVerify.verification == 'มี Tax ID'">
                  <div class="mb-4">
                    <Typography class="pr-3" h5 label="เลขนิติบุคคล" />
                    <div style="width: 100%" class="form-control">
                      <input name="เลขนิติบุคคล" placeholder="0-00-0-000-00000-0" v-model="valueIndividual.id_card" type="text"
                        class="depainput rsu mb-0" v-validate="{
                        }" />
                      <span class="text-error" v-if="errors.has('เลขนิติบุคคล')">{{ errors.first('เลขนิติบุคคล') }}</span>
                    </div>
                  </div>

                  <div class="mb-4">
                    <Typography class="pr-3" h5 label="ชื่อนิติบุคคล" />
                    <div style="width: 100%" class="form-control">
                      <input name="ชื่อนิติบุคคล" placeholder="บริษัทตัวอย่างจำกัด" v-model="valueIndividual.name" type="text"
                        class="depainput rsu mb-0" v-validate="{
                        }" />
                      <span class="text-error" v-if="errors.has('ชื่อนิติบุคคล')">{{ errors.first('ชื่อนิติบุคคล') }}</span>
                    </div>
                  </div>

                  <div class="mb-4">
                    <Typography class="pr-3" h5 label="ชื่อหน่วยงาน" />
                    <div style="width: 100%" class="form-control">
                      <input name="ชื่อหน่วยงาน" placeholder="กรอกชื่อหน่วยงาน" v-model="valueIndividual.institute_name" type="text"
                        class="depainput rsu mb-0" v-validate="{
                        }" />
                      <span class="text-error" v-if="errors.has('ชื่อหน่วยงาน')">{{ errors.first('ชื่อหน่วยงาน') }}</span>
                    </div>
                  </div>

                  <div class="mb-4">
                    <Typography class="pr-3" h5 label="ชื่อผู้ประสานงาน" />
                    <div style="width: 100%" class="form-control">
                      <input name="ชื่อผู้ประสานงาน" placeholder="กรอกชื่อผู้ประสานงาน" v-model="valueIndividual.coordinator_name" type="text"
                        class="depainput rsu mb-0" v-validate="{
                        }" />
                      <span class="text-error" v-if="errors.has('ชื่อผู้ประสานงาน')">{{ errors.first('ชื่อผู้ประสานงาน') }}</span>
                    </div>
                  </div>

                  <div class="mb-4">
                      <Typography class="pr-3" h5 label="อัปโหลดเอกสาร ( ไฟล์  image ,doc, docx,pdf เท่านั้น )" />
                      <uploadalltype
                        v-model="valueIndividual.document"
                        v-validate
                        :multiple="true"
                        :showOnlyButton="true"
                      ></uploadalltype>
                  </div>
                </div>

                <div v-else>
                  <div class="mb-4">
                    <Typography class="pr-3" h5 label="ชื่อหน่วยงาน" />
                    <div style="width: 100%" class="form-control">
                      <input name="ชื่อหน่วยงาน" placeholder="กรอกชื่อหน่วยงาน" v-model="valueIndividual.institute_name" type="text"
                        class="depainput rsu mb-0" v-validate="{
                        }" />
                      <span class="text-error" v-if="errors.has('ชื่อหน่วยงาน')">{{ errors.first('ชื่อหน่วยงาน') }}</span>
                    </div>
                  </div>

                  <div class="mb-4">
                    <Typography class="pr-3" h5 label="ชื่อผู้ประสานงาน" />
                    <div style="width: 100%" class="form-control">
                      <input name="ชื่อผู้ประสานงาน" placeholder="กรอกชื่อผู้ประสานงาน" v-model="valueIndividual.coordinator_name" type="text"
                        class="depainput rsu mb-0" v-validate="{
                        }" />
                      <span class="text-error" v-if="errors.has('ชื่อผู้ประสานงาน')">{{ errors.first('ชื่อผู้ประสานงาน') }}</span>
                    </div>
                  </div>

                  <div v-if="datatypeVerify.type == 'มหาวิทยาลัย'">
                    <div class="mb-4" >
                      <Typography class="pr-3" h5 label="ชื่อคณะ" />
                      <div style="width: 100%" class="form-control">
                        <input name="ชื่อคณะ" placeholder="กรอกชื่อคณะ" v-model="valueIndividual.faculty" type="text"
                          class="depainput rsu mb-0" v-validate="{
                          }" />
                        <span class="text-error" v-if="errors.has('ชื่อคณะ')">{{ errors.first('ชื่อคณะ') }}</span>
                      </div>
                    </div>

                    <div class="mb-4">
                      <Typography class="pr-3" h5 label="รหัสคณะ" />
                      <div style="width: 100%" class="form-control">
                        <input name="รหัสคณะ" placeholder="กรอกรหัสคณะ" v-model="valueIndividual.faculty_id" type="text"
                          class="depainput rsu mb-0" v-validate="{
                          }" />
                        <span class="text-error" v-if="errors.has('รหัสคณะ')">{{ errors.first('รหัสคณะ') }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="mb-4">
                      <Typography class="pr-3" h5 label="อัปโหลดเอกสาร ( ไฟล์  image ,doc, docx,pdf เท่านั้น )" />
                      <uploadalltype
                        v-model="valueIndividual.document"
                        v-validate
                        :multiple="true"
                        :showOnlyButton="true"
                      ></uploadalltype>
                  </div>
                </div>

              <div style="display: flex ;justify-content: center;">
                <v-btn variant="outlined" @click="closeVerifyMember()" color="#BECCDB" style="padding: 10px !important; justify-content: center;">
                    ย้อนกลับ
                </v-btn>
                <v-btn variant="outlined" @click="submitVerifyMember()" color="#BECCDB" style="padding: 10px !important; justify-content: center;">
                    ยืนยัน
                </v-btn>
              </div>

            </v-card>
          </form>
        </v-dialog>


        <div>
          <v-dialog v-model="editModal" persistent width="600px">
            <member-info-edit @closemodal="closemodal" @saveedit="saveedit" v-if="editModal" :inputEdit="inputEdit"
              :isEdit="isEdit"></member-info-edit>
          </v-dialog>
        </div>
        <v-dialog v-model="modalStatusDP" persistent width="400px">
          <v-card style="border-radius: 10px">
            <div class="pa-3">
              <div style="display: flex; justify-content: space-between">
                <div></div>
                <Typography h2 bold label="เปลี่ยนสถานะ" />
                <v-icon style="display: flex; align-items: center" @click="modalStatusDP = false">close</v-icon>
              </div>
              <div class="rsu">
                <v-layout row wrap>
                  <v-flex xs12 class="mb-2 mt-2 pr-1">
                    <Typography class="pr-3" h5 label="สถานะ" />
                    <div style="width: 100%" class="form-control">
                      <DropdownMenu v-model="statusDP" :options="['DP', 'Non-DP', 'รออนุมัติ DP']">
                        <input placeholder="DP type" type="text" class="depainput rsu" :value="statusDP" />
                      </DropdownMenu>
                    </div>
                  </v-flex>
                </v-layout>
                <div style="display: flex; justify-content: center">
                  <Button :loading="searchloading" outline :label="$t('cancel')" @click="modalStatusDP = false" />
                  <Button :loading="searchloading" depressed :label="$t('Save')" @click="editStatusDP()" />
                </div>
              </div>
            </div>
          </v-card>
        </v-dialog>
        <v-dialog v-model="modalExport" persistent width="400px">
          <v-card style="border-radius: 10px">
            <div class="pa-3">
              <div style="display: flex; justify-content: space-between">
                <div></div>
                <div></div>

                <v-icon style="display: flex; align-items: center" @click="modalExport = false">close</v-icon>
              </div>
              <div class="rsu">
                <v-layout column wrap justify-center align-center class="mb-3">
                  <img src="/static/img/Export.png" alt class="responsive-img mb-1" style="height: 70px" />
                  <Typography h2 bold label="ส่งออกข้อมูล" />
                  <Typography h5 medium label="คุณแน่ใจหรือไม่ว่าต้องการส่งออกข้อมูลตามที่เลือก" />
                </v-layout>
                <div class="text-xs-center">
                  <div class="text-xs-center rsu">
                    <v-btn :loading="searchloading" class="rsu" round small outline color="primary"
                      @click.stop="modalExport = false">ยกเลิก</v-btn>
                    <v-btn class="rsu" :loading="searchloading" round small depressed style="color: #ffef01"
                      color="primary" @click.stop="exportData()">ยืนยัน</v-btn>
                  </div>
                </div>
              </div>
            </div>
          </v-card>
        </v-dialog>
        <v-dialog v-model="modalDBD" persistent width="400px">
          <v-card style="border-radius: 10px">
            <div class="pa-4">
              <div style="display: flex; justify-content: space-between; align-items: center">
                <Typography h2 bold label="ข้อมูล DBD" />
                <v-icon @click="modalDBD = false">close</v-icon>
              </div>
              <div class="rsu">
              <table class="table table-bordered table-hover">
                <thead>
                  <tr>
                    <th class="text-xs-center" style="font-size: 1.3em;">รายการ</th>
                    <th class="text-xs-center" style="font-size: 1.3em;">ไฟล์</th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td class="text-xs-center">
                      <div>หนังสือรับรอง</div>
                    </td>
                    <td class="text-xs-center">
                      <a href="#" @click="getinformationPDF(id_card)">
                        <i v-if="!loading" class="fas fa-file"></i>
                        <i v-else class="fas fa-spinner fa-spin"></i>
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-center">
                      <div>บัญชีรายชื่อผู้ถือหุ้น</div>
                    </td>
                    <td class="text-xs-center">
                      <a href="#" @click="getshareholderPDF(id_card)">
                        <i v-if="!loading" class="fas fa-file"></i>
                        <i v-else class="fas fa-spinner fa-spin"></i>
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-xs-center">
                      <div>หนังสือบริคณห์สนธิ</div>
                    </td>
                    <td class="text-xs-center">
                      <a href="#" @click="getborikonPDF(id_card)">
                        <i v-if="!loading" class="fas fa-file"></i>
                        <i v-else class="fas fa-spinner fa-spin"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
              </div>
            </div>
          </v-card>
        </v-dialog>
        <div>
          <v-dialog v-model="searchModal" persistent width="850px">
            <member-info-search @closemodal="closemodal" @onsearch="onsearch" v-if="searchModal"
              v-model="searchModal"></member-info-search>
          </v-dialog>
        </div>
      </div>
    </div>
    <Paginations @clickPagination="changepage" @sortPage="sortPage" :pageCount="pageCount" :numberPage="numberPage"
      :page="page" />
    <v-dialog v-model="showSearch" width="500px" persistent>
      <v-card style="border-radius: 10px">
        <v-btn style="float: right" @click="showSearch = false" icon><v-icon>close</v-icon></v-btn>
        <div class="pa-4">
          <div style="display: flex">
            <i class="fa fa-filter color-darkBlue" style="font-size: 18px; display: flex; align-items: center"
              aria-hidden="true"></i>
            <Typography h3 semiBold label="Advanced Search" class="pl-1" />
          </div>
          <div class="rsu">
            <v-layout row wrap>
              <v-flex xs6 class="mb-2 mt-2 pr-1">
                <Typography class="pr-3" h5 label="รหัสสมาชิก" />
                <div style="width: 100%" class="form-control">
                  <input name="รหัสสมาชิก" placeholder="1552366" v-model="search.memberid" type="text"
                    class="depainput rsu mb-0" />
                </div>
              </v-flex>
              <v-flex xs6 class="mb-2 mt-2 pr-1">
                <Typography class="pr-3" h5 label="เลขบัตรประชาชน/เลขนิติบุคคล" />
                <div style="width: 100%" class="form-control">
                  <input name="เลขบัตรประชาชน/เลขนิติบุคคล" v-model="search.id_card" type="number"
                    class="depainput rsu mb-0" placeholder="เลขบัตรประชาชน/เลขนิติบุคคล" />
                </div>
              </v-flex>
              <v-flex xs6 class="mb-2 mt-2">
                <Typography class="pr-3" h5 label="ชื่อสมาชิก" />
                <div style="width: 100%" class="form-control">
                  <input name="กรอกชื่อสมาชิก" placeholder="กุลสตรี" v-model="search.name" type="text"
                    class="depainput rsu mb-0" />
                </div>
              </v-flex>
              <v-flex xs6 class="mb-2 mt-2 pl-1">
                <Typography class="pr-3" h5 label="ชื่อหน่วยงาน" />
                <div style="width: 100%" class="form-control">
                  <input name="ชื่อหน่วยงาน" placeholder="ชื่อหน่วยงาน" v-model="search.institute_name" type="text"
                    class="depainput rsu mb-0" />
                </div>
              </v-flex>
              <v-flex xs6 class="mb-2 mt-2">
                <Typography class="pr-3" h5 label="อีเมล" />
                <div style="width: 100%" class="form-control">
                  <input name="อีเมล" placeholder="อีเมล" v-model="search.email" type="text" class="depainput rsu mb-0" />
                </div>
              </v-flex>
              <v-flex xs6 class="mb-2 mt-2 pl-1">
                <Typography class="pr-3" h5 label="เบอร์" />
                <div style="width: 100%" class="form-control">
                  <input name="เบอร์" placeholder="เบอร์" v-model="search.phone_number" type="text"
                    class="depainput rsu mb-0" />
                </div>
              </v-flex>
              <v-flex xs12 class="mb-2 mt-2">
                <Typography class="pr-3" h5 label="ประเภทสมาชิก" />
                <div v-if="membertype && membertype.length" style="width: 100%" placeholder="เลือกประเภทสมาชิก">
                  <multiselect :options="membertype.map((item) => item.typeid)" :custom-label="
                    (opt) =>
                      membertype.find((x) => x.typeid == opt)
                        ? membertype.find((x) => x.typeid == opt).type
                        : false
                  " :custom-track-by="(opt) => membertype.find((x) => x.typeid == opt).typeid" v-model="search.type"
                    :searchable="true" deselect-label="" :allow-empty="false" single-select />
                </div>
              </v-flex>
              <v-flex xs12>
                <Typography h5 label="แท็ก" />
                <multiselect :options="tagOptions" v-model="search.tags" :placeholder="$t('เลือกแท็ก')" :multiple="true"
                  :taggable="true" @tag="addTag" class="multi-tag-small">
                </multiselect>
              </v-flex>
              <v-flex xs12 class="form-control mt-2">
                <Typography h5 :label="$t('สถานะ DP')" />
                <DropdownMenu v-model="search.dpType" :options="['DP', 'Non-DP', 'รออนุมัติ DP']">
                  <input placeholder="เลือกสถานะ" :value="search.dpType" readonly type="text" class="depainput rsu" />
                </DropdownMenu>
              </v-flex>
              <v-flex xs6 class="mb-2 mt-2">
                <Typography class="pr-3" h5 label="สถานะ Odoo" />
                <div style="width: 100%" class="form-control">
                  <DropdownMenu :options="['unconfirmed', 'confirm', 'rejected']" v-model="search.status"
                    :statustype="true">
                    <input name="StatusOdoo" :style="'color: ' + statusColor(search.status) + ' !important'"
                      placeholder="เลือกสถานะ Odoo" :value="statusLabel(search.status)" type="text"
                      class="depainput rsu mb-0" />
                  </DropdownMenu>
                </div>
              </v-flex>
              <v-flex xs6 class="mb-2 mt-2 pl-1">
                <Typography class="pr-3" h5 label="รวม Odoo" />
                <div style="width: 100%" class="form-control">
                  <input name="ข้อมูล Odoo" v-model="search.memberid1" type="text" class="depainput rsu mb-0" />
                </div>
              </v-flex>

              <v-flex xs6 class="mb-2 mt-2">
                <Typography class="pr-3" h5 label="ข้อมูล Odoo" />
                <div style="width: 100%" class="form-control">
                  <input name="ข้อมูล Odoo" v-model="search.memberid2" type="text" class="depainput rsu mb-0" />
                </div>
              </v-flex>
              <v-flex xs6 class="mb-2 mt-2 pl-1">
                <Typography class="pr-3" h5 label="สถานะ" />
                <div style="width: 100%" class="form-control">
                  <DropdownMenu :options="['unconfirmed', 'confirm', 'rejected', 'pending']" v-model="search.status2"
                    :statustype="true">
                    <input name="Status" :style="'color: ' + statusColor(search.status2) + ' !important'"
                      placeholder="เลือกสถานะ" :value="statusLabel(search.status2)" type="text"
                      class="depainput rsu mb-0" />
                  </DropdownMenu>
                </div>
              </v-flex>
            </v-layout>
            <div class="pt-2" style="display: flex; justify-content: center">
              <Button :loading="searchloading" outline :label="$t('Clear Search')" @click="clearSearch" />
              <Button :loading="searchloading" depressed :label="$t('Search')" @click="onSearch" />
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="modalOdoo" width="640px" persistent>
      <v-card v-if="modalOdoo">
        <div class="text-xs-right">
          <v-btn icon @click="modalOdoo = false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <div class="px-4 pb-3">
          <!-- <div class="primary--text" style="font-size: 21px; font-weight: bold">Odoo Info</div> -->
          <Typography bold h3 label="Odoo Info" />
          <div class="mt-2" v-if="currentOdoo && currentOdoo.length">
            <v-card class="pa-2 mb-3" v-for="(item, k) in currentOdoo" :key="k" style="position: relative">
              <!-- <div style="font-weight: bold">{{ item.vendorName }}</div> -->
              <Typography bold h6 :label="item.vendorName" />
              <Typography h6 :label="'โครงการ' + item.projectName" />
              <Typography h6 :label="'สถานะ :' + item.plan_status ? item.plan_status : '-'" />
              <Typography h6 :label="'รหัสสัญญา :' + item.contract_code ? item.contract_code : '-'" />
              <Typography h6 :label="'เลขที่สัญญา :' + item.contractNumber ? item.contractNumber : '-'" />
              <!-- <div>โครงการ {{ item.projectName }}</div> -->
              <!-- <div>สถานะ : {{ item.plan_status ? item.plan_status : '-' }}</div> -->
              <!-- <div style="font-size: 13px">รหัสสัญญา : {{ item.contract_code }}</div> -->
              <!-- <div style="font-size: 13px">เลขที่สัญญา : {{ item.contractNumber }}</div> -->
              <div style="position: absolute; right: 3px; top: 2px; font-size: 14px">
                {{ moment(item.start_date).format('DD/MM/YYYY') }} -
                {{ moment(item.end_date).format('DD/MM/YYYY') }}
              </div>
              <div style="position: absolute; right: 3px; bottom: 2px">
                <!-- วันครบกำหนด :
                {{ item.due_date ? moment(item.due_date).format('DD/MM/YYYY HH:mm') : '-' }} -->
                <Typography h6 :label="
                  'วันครบกำหนด :' + item.due_date
                    ? moment(item.due_date).format('DD/MM/YYYY HH:mm')
                    : '-'
                " />
              </div>

              <!-- {{ item }} -->
            </v-card>
          </div>
          <div class="mt-2" v-else>
            <!-- <div class="text-xs-center" style="font-size: 20px">ไม่มีข้อมูล</div> -->
            <Typography center h5 label="ไม่มีข้อมูล" />
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showHistory" width="570px" persistent>
      <v-card style="border-radius: 10px">
        <div class="pa-4">
          <div style="display: flex; justify-content: space-between; align-items: center">
            <!-- <span class="rsu color-darkBlue bold7 fs-24">
              ประวัติ
            </span> -->
            <Typography h2 bold label="ประวัติ" />
            <v-icon @click="showHistory = false">close</v-icon>
          </div>
          <div class="rsu">
            <v-layout row wrap>
              <v-data-table expand hide-actions :loading="loading" :headers="[
                {
                  text: 'วันที่ / เวลา',
                  align: 'center',
                  value: 'date',
                },
                {
                  text: 'รายการ',
                  align: 'center',
                  value: 'name',
                },
                {
                  text: 'ผู้ดำเนินการ',
                  align: 'center',
                  value: 'adminid',
                },
              ]" :items="depamemberlogs" select-all item-key="name" class="elevation-1" style="height: 400px">
                <template v-slot:headers="props">
                  <tr style="background-color: #152d53; color: white">
                    <th style="background-color: #152d53; color: yellow" v-for="header in props.headers"
                      :key="header.text">
                      <div>{{ header.text }}</div>
                    </th>
                  </tr>
                </template>
                <template v-slot:items="props">
                  <tr style="cursor: pointer">
                    <td class="text-xs-left">
                      {{
                        props.item.created_at
                        ? props.item.created_at
                        : '-' | DateFormat('DD/MM/YYYY HH:MM')
                      }}
                    </td>
                    <td class="text-xs-left">
                      {{ props.item.name ? props.item.name : '-' }}
                    </td>
                    <td class="text-xs-left">
                      {{ props.item.adminid ? props.item.adminid : '-' }}
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-layout>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showPayment" width="450px" persistent>
      <v-card style="border-radius: 10px">
        <div class="pt-4 pb-4 pl-5 pr-5">
          <div style="display: flex; justify-content: space-between">
            <div></div>
            <Typography h2 bold label="ข้อมูลสลิป" />
            <v-icon style="display: flex; align-items: center" @click="showPayment = false">close</v-icon>
          </div>
          <div class="rsu">
            <v-layout row wrap>
              <v-flex xs12 class="mb-2 mt-2 pr-1 center">
                <v-img v-if="slipData.slipfile" class="ma-auto" position="'center center'" :width="250"
                  :src="slipData.slipfile ? slipData.slipfile : ''" />
                <Typography v-else h3 bold label="ไม่พบข้อมูล" />
              </v-flex>
              <v-flex xs12 class="pl-2 mb-1 mt-2 pr-1 center" style="display: flex">
                <Typography h5 bold label="รหัสอ้างอิง 1 : " />
                <Typography class="ml-2" h5 semiBold :label="
                  slipData.qrcode_data && slipData.qrcode_data.ref1 != ''
                    ? slipData.qrcode_data.ref1
                    : 'ไม่พบข้อมูล'
                " />
              </v-flex>
              <v-flex xs12 class="pl-2 center" style="display: flex">
                <Typography h5 bold label="รหัสอ้างอิง 2 : " />
                <Typography class="ml-2" h5 semiBold :label="
                  slipData.qrcode_data && slipData.qrcode_data.ref2 != ''
                    ? slipData.qrcode_data.ref2
                    : 'ไม่พบข้อมูล'
                " />
              </v-flex>
              <v-flex xs12 class="center" style="display: flex">
                <div class="amountDetail">
                  <Typography class="ml-2" h6 semiBold label="ยอดที่ต้องชำระ" />
                  <Typography color="color-error" class="ml-2" h7 semiBold label="฿" />
                  <Typography color="color-error" class="ml-2" h1 bold
                    :label="slipData.amount && slipData.amount != '' ? slipData.amount : '0'" />
                </div>
              </v-flex>
              <v-flex xs6 class="mb-2 mt-2">
                <Typography class="ml-2" h5 semiBold label="วันที่ชำระเงิน" />
                <Typography class="ml-2" h5 :label="
                  slipData.paid_date
                    ? moment(slipData.paid_date).format('DD/MM/YYYY')
                    : 'ไม่พบข้อมูล'
                " />
              </v-flex>
              <v-flex xs6 class="mb-2 mt-2">
                <Typography class="ml-2" h5 semiBold label="เวลาชำระเงิน" />
                <Typography class="ml-2" h5
                  :label="slipData.paid_time ? moment(paid_time).format('HH:mm') : 'ไม่พบข้อมูล'" />
              </v-flex>
              <v-flex xs12 class="mb-2 mt-2">
                <Typography class="ml-2" h5 semiBold label="ธนาคารที่ทำการชำระเงิน" />
                <Typography class="ml-2" h5 :label="slipData.bankname ? slipData.bankname : 'ไม่พบข้อมูล'" />
              </v-flex>
            </v-layout>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import MemberInfoEdit from './MemberInfoEdit.vue'
import InputSearch from '@/components/elements/InputSearch.vue'
import Paginations from '@/components/elements/Paginations.vue'

import config from '@/config'
import api from '@/api'
import { mapGetters } from 'vuex'
import DropdownMenu from '@/components/elements/DropdownMenu.vue'
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import Exportxlsx from '../../elements/exportxlsx.vue'
import Typography from '@/components/elements/Typography.vue'
import TooltipTable from '@/components/elements/TooltipTable.vue'
import Button from '@/components/elements/Button.vue'
//import imgShowPass from '../../../../static/icon/showPass.png'
//import imgHidePass from '../../../../static/icon/hidePass.png'
import DatePicker from 'vue2-datepicker'
import UploadDocument from '@/components/elements/UploadDocument.vue'
import uploadfile from '@/components/elements/uploadfile.vue'
import uploadalltype from '@/components/elements/uploadalltype'
import base64js from 'base64-js';
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from '@/assets/fonts/vfs_fonts.js'

import * as dayjs from 'dayjs'
let buddhistEra = require('dayjs/plugin/buddhistEra')
dayjs.extend(buddhistEra)
require('dayjs/locale/th')

pdfMake.vfs = pdfFonts.pdfMake.vfs
pdfMake.fonts = {
  THSarabunNew: {
    normal: 'THSarabunNew.ttf',
    bold: 'THSarabunNew Bold.ttf',
    italics: 'THSarabunNew-Italic.ttf',
    bolditalics: 'THSarabunNew-BoldItalic.ttf'
  }
}

export default {
  components: {
    MemberInfoEdit,
    DropdownMenu,
    Multiselect,
    Exportxlsx,
    InputSearch,
    TooltipTable,
    Paginations,
    Typography,
    Button,
    DatePicker,
    UploadDocument,
    uploadfile,
    uploadalltype,
  },

  data() {
    return {
      isSearch: false,
      column: [
        'รหัสสมาชิก',
        'ชื่อ - นามสกุล',
        'สถานะ DP',
        'อีเมล',
        'เบอร์',
        'สถาบัน',
        // 'PIC',
        'แท็ก',
        'ประเภทสมาชิก',
        'สถานะ Odoo',
        'รวม Odoo',
        'ข้อมูล Odoo',
        'สถานะ',
        'SME ONE ID',
        'DBD',
        'สถานะการจ่ายเงิน',
        'สลิป',
        'ประวัติ',
        'ข้อมูลร้านค้า',
      ],
      columnAll: [
        'รหัสสมาชิก',
        'ชื่อ - นามสกุล',
        'สถานะ DP',
        'อีเมล',
        'เบอร์',
        'สถาบัน',
        // 'PIC',
        'แท็ก',
        'ประเภทสมาชิก',
        'สถานะ Odoo',
        'รวม Odoo',
        'ข้อมูล Odoo',
        'สถานะ',
        'SME ONE ID',
        'DBD',
        'สถานะการจ่ายเงิน',
        'สลิป',
        'ประวัติ',
        'ข้อมูลร้านค้า',
      ],
      showColumn: [
        'รหัสสมาชิก',
        'ชื่อ - นามสกุล',
        'สถานะ DP',
        'อีเมล',
        'เบอร์',
        'สถาบัน',
        // 'PIC',
        'แท็ก',
        'ประเภทสมาชิก',
        'สถานะ Odoo',
        'รวม Odoo',
        'ข้อมูล Odoo',
        'สถานะ',
        'SME ONE ID',
        'DBD',
        'สถานะการจ่ายเงิน',
        'สลิป',
        'ประวัติ',
        'ข้อมูลร้านค้า',
      ],
      page: 1,
      numberPage: {
        page: undefined,
      },
      slipData: {},
      showPayment: false,
      showSearch: false,
      showHistory: false,
      tagOptions: [],
      update_tags: [],
      searchloading: false,
      test: false,
      loading: true,
      drawer: false,
      isEdit: false,
      clearAdvancedSearch: false,
      search: {
        nameAll: '',
        name: '',
        institute_name: '',
        memberid: '',
        email: '',
        id_card: '',
        phone_number: '',
        status: '',
        type: '',
        dpType: '',
        tags: [],
        agencyname: '',
      },
      pagination: {
        sortBy: 'memberid',
        descending: false,
        rowsPerPage: 50,
      },
      inputEdit: {},
      filter: {},
      searchColumn: '',
      statusDP: '',
      editModal: false,
      modalStatusDP: false,
      modalExport: false,
      modalDBD: false,
      modalStatusDPEdit: {},
      searchModal: false,
      desserts: [],
      dessertsTotal: 0,
      headers: [
        {
          text: 'รหัสสมาชิก',
          align: 'center',
          value: 'memberid',
        },
        {
          text: 'ชื่อ - นามสกุล',
          align: 'left',
          value: 'name',
        },
        {
          text: 'สถานะ DP',
          align: 'center',
          value: 'dptype',
        },
        {
          text: 'อีเมล',
          align: 'left',
          value: 'email',
        },
        {
          text: 'เบอร์',
          align: 'left',
          value: 'phone_number',
        },
        {
          text: 'สถาบัน',
          align: 'left',
          value: 'institution',
        },
        // {
        //   text: 'PIC',
        //   align: 'center',
        //   value: 'pic',
        // },
        {
          text: 'แท็ก',
          align: 'left',
          value: 'tags',
        },
        {
          text: 'ประเภทสมาชิก',
          align: 'left',
          value: 'Member Type',
        },
        {
          text: 'สถานะ Odoo',
          align: 'center',
          value: 'odoo_status',
          sortable: false,
        },
        {
          text: 'รวม Odoo',
          align: 'center',
          value: 'odoo_total',
          sortable: false,
        },
        {
          text: 'ข้อมูล Odoo',
          align: 'center',
          value: 'odoo_info',
          sortable: false,
        },
        {
          text: 'สถานะ',
          align: 'center',
          value: 'status',
        },
        {
          text: 'SME ONE ID',
          align: 'center',
          value: 'sme_status',
        },
        {
          text: 'DBD',
          align: 'center',
          value: 'dbd',
        },
        {
          text: '',
          align: 'center',
          value: '',
        },
        {
          text: 'สถานะการจ่ายเงิน',
          align: 'center',
          value: 'payment_status',
        },
        {
          text: 'สลิป',
          align: 'center',
          value: '',
        },
        {
          text: 'ประวัติ',
          align: 'center',
          value: '',
        },
        {
          text: 'ข้อมูลร้านค้า',
          align: 'center',
          value: '',
        },
        {
          text: '',
          align: 'center',
          value: '',
        },
        {
          text: '',
          align: 'center',
          value: '',
        },
      ],
      firstUserId: [],
      rowsPerPage: 100,
      membertype: [],
      currentOdoo: '',
      modalOdoo: false,
      exdata: [],
      depamemberlogs: [],
      depamemberdbd: [],

      memberNewUser: '',
      memberNewUserData: {},
      modalAddMember: false,
      memberAddUser: 'email',
      memberAdd: {
        phone: '',
        email: '',
        password: '',
        confirmPassword: '',
        agencyId:'',
      },
      imgHidePass: require("../../../../static/icon/hidePass.png"),
      imgShowPass: require("../../../../static/icon/showPass.png"),
      showPassword: false,
      showConfirmPassword: false,
      typeInput: "password",
      typeInputConfirmPassword: "password",

      modalVerifyMemberType: false,
      membertypeVerify: {},//select เท่านั้น
      datatypeVerify: {},//status= "นิติบุคคล" "บุคคลธรรมดา" //verification //type

      modalVerifyMember: false,
      itemRadio: [
        {
          label: "มีวันเดือนปีเกิดครบถ้วน",
          value: "มีวันเดือนปีเกิดครบถ้วน",
          class: "radioNotChecked",
        },
        {
          label: "มีเฉพาะเดือนและปีเกิด",
          value: "มีเฉพาะเดือนและปีเกิด",
          class: "radioNotChecked",
        },
        {
          label: "มีเฉพาะปีเกิด",
          value: "มีเฉพาะปีเกิด",
          class: "radioNotChecked",
        },
      ],
      valueIndividual: {
        name: "",
        surname: "",
        birthdayRadio: "มีวันเดือนปีเกิดครบถ้วน",
        dob:"",
        id_card: "",
        laser_no: "",
        document:"",
        institute_name:"",
        coordinator_name:"",
        faculty:"",
        faculty_id:"",
      },
    }
  },
  computed: {
    techhuntUrl() {
      return config.techhuntUrl
    },
    xlsxMember() {
      var result = this.exdata.map((el) => {
        return {
          'เลขรหัสสมาชิก depa member': el.memberid,
          ชื่อบริษัท: this.filteredName(el) || el.name || el.institute_name,
          'เลขบัตรประชาชน/เลขนิติบุคคล': el.id_card,
          จังหวัด: '',
          ข้อมูลบริษัท: el.detail,
          รูปภาพรูปโลโก้บริษัท: el.profile_pic,
          ชื่อผู้ประสานงาน: el.coordinator_name,
          อีเมล์: el.email,
          เบอร์โทรศัพท์: el.phone_number,
          หน่วยงาน: el.institute_name,
          แท็ก: el.tags,
          'สถานะ DP': el.dptype,
          'Member Type': el.membertype,
          สถานะ: el.status,
          website: el.website,
          'ชื่อผลิตภัณฑ์ และ ราคา': el.productlist,
          'สถานะ Odoo': el.odooinfo ? el.odooinfo[1].plan_status : '',
          'Odoo total amount': el.odooinfo && el.odooinfo.total ? el.odooinfo.total : '',
          'ข้อมูล Odoo': el.odooinfo ? JSON.stringify(el.odooinfo) : '',
        }
      })
      return result
    },
    pageCount() {
      if (this.dessertsTotal !== 0) {
        let count = Math.ceil(this.dessertsTotal / this.rowsPerPage)
        return count
      } else {
        return 0
      }
    },
    limitCom() {
      return this.rowsPerPage
    },
    offsetCom() {
      return this.page ? this.page * this.rowsPerPage - this.rowsPerPage : this.rowsPerPage
    },
    moment() {
      return moment
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang',
    }),
  },

  async mounted() {
    this.loading = true
    await this.getdepamemberinfoall()
    await this.getdepamembertypeall()

    this.depafirstAllowMember()
    this.loading = false

  },
  methods: {
    async getshareholderPDF(item) {
      this.loading = true;   

      try {
        let res = await api.getshareholderPDF({ juristicId: item });
        this.shareholder = res.data.data;

        if (this.shareholder) {
          let res2 = await api.getshareholderDownloadPDF({ juristicId: item, jobid: this.shareholder.JobID})   
                
          this.shareholderpdf = res2.data.data   
          if(this.shareholderpdf){
              this.repairshareholderBase64(this.shareholderpdf,item ,'shareholder')
          }  
          else{
            this.$swal.fire({
              title: 'ไม่มีข้อมูล',
              html: `<div>ไม่พบไฟล์บัญชีรายชื่อผู้ถือหุ้น</div>`,
              confirmButtonText: 'ปิด'
            });

          }          
             
        } else {
          this.$swal.fire({
            title: '<div style="color:background: rgba(12, 47, 83, 1);"> เกิดข้อผิดพลาด </div>',
            html: `<div> ไม่สามารถดาวน์โหลดไฟล์ได้ </div>`,
            showCancelButton: false,
            showCloseButton: true,
            confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
            width: '590px'
          });
        }
      } catch (err) {
        console.error(err);

        this.$swal.fire({
          title: '<div style="color:background: rgba(12, 47, 83, 1);"> เกิดข้อผิดพลาด </div>',
          html: `<div> ระบบล้มเหลว กรุณาลองใหม่ </div>`,
          confirmButtonText: 'ปิด'
        });

      } finally {
        this.loading = false;  
      }
    },
    // async getshareholderPDF(item) {
    //     let res = await api.getshareholderPDF({ juristicId: item })
    //     this.shareholder = res.data.data
    //     if(this.shareholder){
          
    //       let res2 = await api.getshareholderDownloadPDF({ juristicId: item, jobid: this.shareholder.JobID})          
    //       this.shareholderpdf = res2.data.data               
    //       this.repairshareholderBase64(this.shareholderpdf,item ,'shareholderpdf')   
    //     }
    //     else{
    //       this.$swal.fire({
    //         title: '<div style="color:background: rgba(12, 47, 83, 1);"> เกิดข้อผิดพลาด </div>',
    //         html: `<div> ไม่สามารถดาวน์โหลดไฟล์ได้ </div>`,
    //         showCancelButton: false,
    //         showCloseButton: true,
    //         confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
    //         width: '590px'
    //       })
    //     }
        
    // },
    async getinformationPDF(item) {
      this.loading = true;   

      try {
        let res = await api.getinformationPDF({ juristicId: item });
        this.information = res.data.data;

        if (this.information) {
          this.repairBase64(this.information, item, 'information');
        } else {
          this.$swal.fire({
            title: '<div style="color:background: rgba(12, 47, 83, 1);"> เกิดข้อผิดพลาด </div>',
            html: `<div> ไม่สามารถดาวน์โหลดไฟล์ได้ </div>`,
            showCancelButton: false,
            showCloseButton: true,
            confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
            width: '590px'
          });
        }
      } catch (err) {
        console.error(err);

        this.$swal.fire({
          title: '<div style="color:background: rgba(12, 47, 83, 1);"> เกิดข้อผิดพลาด </div>',
          html: `<div> ระบบล้มเหลว กรุณาลองใหม่ </div>`,
          confirmButtonText: 'ปิด'
        });

      } finally {
        this.loading = false;  
      }
    },
    // async getinformationPDF(item) {
    //     let res = await api.getinformationPDF({ juristicId: item })
    //     this.information = res.data.data
    //     if(this.information){
    //       this.repairBase64(this.information,item,'information')     
    //     }
    //     else{
    //       this.$swal.fire({
    //         title: '<div style="color:background: rgba(12, 47, 83, 1);"> เกิดข้อผิดพลาด </div>',
    //         html: `<div> ไม่สามารถดาวน์โหลดไฟล์ได้ </div>`,
    //         showCancelButton: false,
    //         showCloseButton: true,
    //         confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
    //         width: '590px'
    //       })
    //     }
    // },
    async getborikonPDF(item) {
      this.loading = true;   

      try {
        let res = await api.getborikonPDF({ juristicId: item });
        this.borikon = res.data.data

        if(this.borikon){
          this.repairBase64(this.borikon,item,'borikon')     
        } else{
          this.$swal.fire({
            title: '<div style="color:background: rgba(12, 47, 83, 1);"> เกิดข้อผิดพลาด </div>',
            html: `<div> ไม่สามารถดาวน์โหลดไฟล์ได้ </div>`,
            showCancelButton: false,
            showCloseButton: true,
            confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
            width: '590px'
          })
        }
      } catch (err) {
        console.error(err);

        this.$swal.fire({
          title: '<div style="color:background: rgba(12, 47, 83, 1);"> เกิดข้อผิดพลาด </div>',
          html: `<div> ระบบล้มเหลว กรุณาลองใหม่ </div>`,
          confirmButtonText: 'ปิด'
        });

      } finally {
        this.loading = false;  
      }
    },
    // async getborikonPDF(item) {
    //     let res = await api.getborikonPDF({ juristicId: item })
    //     this.borikon = res.data.data
    //     if(this.borikon){
    //       this.repairBase64(this.borikon,item,'borikon')     
    //     }
    //     else{
    //       this.$swal.fire({
    //         title: '<div style="color:background: rgba(12, 47, 83, 1);"> เกิดข้อผิดพลาด </div>',
    //         html: `<div> ไม่สามารถดาวน์โหลดไฟล์ได้ </div>`,
    //         showCancelButton: false,
    //         showCloseButton: true,
    //         confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
    //         width: '590px'
    //       })
    //     }
    // },
    repairBase64(data,item,file) {
      try {        
        const jsonString = JSON.stringify(data);
        
        const byteArray = new TextEncoder().encode(jsonString);
        let base64String = base64js.fromByteArray(byteArray);


        const decodedArray = base64js.toByteArray(base64String);
        this.decodedJsonString = new TextDecoder().decode(decodedArray);
        this.decodedJson = JSON.parse(this.decodedJsonString);

        this.decodedResult = this.decodedJson.Result || 'No result found';
        this.base64Output = this.decodedResult.replace(/-/g, '+').replace(/_/g, '/');   

        const byteCharacters = atob(this.base64Output);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray2 = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray2], { type: 'application/pdf' });
        const blobUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = `${file}-${item}.pdf`;
        link.click();
        URL.revokeObjectURL(blobUrl);
        
        
      } catch (error) {
        console.log(error);
        this.decodedOutput = 'Invalid Base64 string';
      }
    },
    repairshareholderBase64(data,item,file) {
      
      try { 
        
          const jsonString = data.ListOfFile[0].Result;
       
          this.base64Output = jsonString.replace(/-/g, '+').replace(/_/g, '/');            

          const byteCharacters = atob(this.base64Output);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray2 = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray2], { type: 'application/pdf' });
          const blobUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = blobUrl;
          link.download = `${file}-${item}.pdf`;
          link.click();
          URL.revokeObjectURL(blobUrl);
        
      } catch (error) {
        console.log(error);
        this.decodedOutput = 'Invalid Base64 string';
      }
    },
    openModalDBD(item) {
      this.modalDBD = true;
      this.id_card = item.id_card;
    },    
    closeModalAddMember(){
      this.modalAddMember = false
      this.memberAdd = {
                phone: '',
                email: '',
                password: '',
                confirmPassword: '',
                agencyId:'',
              }
    },
    async submitMemberAdd() {

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const phoneRegex = /^\d{10}$/;
      const passwordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%&0-9]).{8,}$/;

      if (this.memberAddUser == 'phone') {
        if (!(phoneRegex.test(this.memberAdd.phone))) {
          await this.$swal.fire({
            title: '<div style="color:background: rgba(12, 47, 83, 1);"> เกิดข้อผิดพลาด </div>',
            html: `<div> รูปแบบเบอร์โทรศัพท์ไม่ถูกต้อง </div>`,
            showCancelButton: false,
            showCloseButton: true,
            confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
            width: '590px'
          })
        }

      } else if (this.memberAddUser == 'email') {

        if (!(emailRegex.test(this.memberAdd.email))) {
          await this.$swal.fire({
            title: '<div style="color:background: rgba(12, 47, 83, 1);"> เกิดข้อผิดพลาด </div>',
            html: `<div> รูปแบบอีเมลไม่ถูกต้อง </div>`,
            showCancelButton: false,
            showCloseButton: true,
            confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
            width: '590px'
          })
        }

      }
      if (!(passwordRegex.test(this.memberAdd.password))) {
        await this.$swal.fire({
          title: '<div style="color:background: rgba(12, 47, 83, 1);"> เกิดข้อผิดพลาด </div>',
          html: `<div> - ตัวอักษรภาษาอังกฤษพิมพ์ใหญ่อย่างน้อย 1 ตัว </div>
                 <div> - ตัวอักษรภาษาอังกฤษพิมพ์เล็กอย่างน้อย 1 ตัว </div>
                 <div> - อักขระพิเศษ (!,@,#,$,%,&) หรือ ตัวเลขอย่างน้อย 1 ตัว </div>
                 <div> - ความยาวอย่างน้อย 8 ตัวอักษร </div>`,
          showCancelButton: false,
          showCloseButton: true,
          confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
          width: '590px'
        })

      } else if (this.memberAdd.password != this.memberAdd.confirmPassword) {
        await this.$swal.fire({
          title: '<div style="color:background: rgba(12, 47, 83, 1);"> เกิดข้อผิดพลาด </div>',
          html: `<div> รหัสผ่านและยืนยันรหัสผ่านไม่ตรงกัน </div>`,
          showCancelButton: false,
          showCloseButton: true,
          confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
          width: '590px'
        })
      }

      const data = {
        phone_number: this.memberAdd.phone && this.memberAddUser == 'phone' ? this.memberAdd.phone : '',
        email: this.memberAdd.email && this.memberAddUser == 'email' ? this.memberAdd.email : '',
        password: this.memberAdd.password ? this.memberAdd.password : '',
        confirmPassword: this.memberAdd.confirmPassword ? this.memberAdd.confirmPassword : '',
        agencyId: this.memberAdd.agencyId ? this.memberAdd.agencyId : '',
      }
      try{
        if(this.memberAddUser == 'phone'){
          const res = await api.techhuntRegisterPhoneAdmin(data)
          if(res.reason == 'Phone number already registered') {
            await this.$swal.fire({
              title: '<div style="color:background: rgba(12, 47, 83, 1);"> เกิดข้อผิดพลาด </div>',
              html: `<div> หมายเลขโทรศัพท์นี้ถูกลงทะเบียนไว้แล้ว </div>`,
              showCancelButton: false,
              showCloseButton: true,
              confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
              width: '590px'
            })
          }
          if(res.data[0].success){
            this.memberNewUser = res.data[0].memberid
            this.memberNewUserData = res.data[0].data
          }
        }else if(this.memberAddUser == 'email'){
          const res = await api.techhuntRegisterEmailAdmin(data)
          if(res.reason == 'Email already registered') {
            await this.$swal.fire({
              title: '<div style="color:background: rgba(12, 47, 83, 1);"> เกิดข้อผิดพลาด </div>',
              html: `<div> อีเมลนี้ถูกลงทะเบียนไว้แล้ว </div>`,
              showCancelButton: false,
              showCloseButton: true,
              confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
              width: '590px'
            })
          }
          if(res.data[0].success == true){
            this.memberNewUser = res.data[0].memberid
            this.memberNewUserData = res.data[0].data
          }
        }

        this.modalAddMember = false
        this.modalVerifyMemberType = true
        this.memberAdd = {
          phone: '',
          email: '',
          password: '',
          confirmPassword: '',
          agencyId:'',
        }
      }catch(e){
        console.error(e)
      }
    },
    toggleShow() {
      this.showPassword = !this.showPassword;
      this.typeInput = this.showPassword ? "text" : "password";
    },
    toggleShowConfirm() {
      this.showConfirmPassword = !this.showConfirmPassword;
      this.typeInputConfirmPassword = this.showConfirmPassword
        ? "text"
        : "password";
    },
    closeModalVerifyMemberType(){
      this.modalVerifyMemberType = false
      this.membertypeVerify = {}
    },
    submitVerifyMemberType(){
      const VerifyMember = this.membertype.find((item)=> item.typeid === this.membertypeVerify)
      this.datatypeVerify = VerifyMember
      this.modalVerifyMemberType = false
      this.modalVerifyMember = true
    },
    async submitVerifyMember(){
     // บุคคลธรรมดา นิติบุคคล
     try{
      let data
      if(this.datatypeVerify.verification == 'บุคคลธรรมดา' || this.datatypeVerify.verification == 'เกษตรกร'){
        const DOB = dayjs(this.valueIndividual.dob).format('YYYY-MM-DD')
        data = {
          ...this.memberNewUserData,
          name: this.valueIndividual.name ? this.valueIndividual.name : null,
          surname: this.valueIndividual.surname ? this.valueIndividual.surname : null,
          birthdayRadio: this.valueIndividual.birthdayRadio ? this.valueIndividual.birthdayRadio : null,
          dob: DOB,
          id_card: this.valueIndividual.id_card ? this.valueIndividual.id_card : null,
          laser_no: this.valueIndividual.laser_no ? this.valueIndividual.laser_no : null,
          document:this.valueIndividual.document ? this.valueIndividual.document : null,
          //memberid: this.memberNewUser,
          pageid: 'DEPA',
          membertype: this.datatypeVerify.type,
          membertype_id: this.datatypeVerify.typeid,
          verification: this.datatypeVerify.verification,
          status: 'confirm',
        }
        

      }else if(this.datatypeVerify.verification == 'มี Tax ID'){
        data = {
          ...this.memberNewUserData,
          id_card: this.valueIndividual.id_card ? this.valueIndividual.id_card : null,
          name: this.valueIndividual.name ? this.valueIndividual.name : null,
          institute_name: this.valueIndividual.institute_name ? this.valueIndividual.institute_name : null,
          coordinator_name:this.valueIndividual.coordinator_name ? this.valueIndividual.coordinator_name : null,
          document:this.valueIndividual.document ? this.valueIndividual.document : null,

         // memberid: this.memberNewUser,
          pageid: 'DEPA',
          membertype: this.datatypeVerify.type,
          membertype_id: this.datatypeVerify.typeid,
          verification: this.datatypeVerify.verification,
          status: 'confirm',
        }

      }else {
        data = {
          ...this.memberNewUserData,
          document:this.valueIndividual.document ? this.valueIndividual.document : null,
          coordinator_name:this.valueIndividual.coordinator_name ? this.valueIndividual.coordinator_name : null,
          institute_name: this.valueIndividual.institute_name ? this.valueIndividual.institute_name : null,
          faculty: this.valueIndividual.faculty ? this.valueIndividual.faculty : null,
          faculty_id: this.valueIndividual.faculty_id ? this.valueIndividual.faculty_id : null,
          //memberid: this.memberNewUser,
          pageid: 'DEPA',
          membertype: this.datatypeVerify.type,
          membertype_id: this.datatypeVerify.typeid,
          verification: this.datatypeVerify.verification,
          status: 'confirm',
        }
      }

      const res = await api.depamemberinfo(data)
      if (res.data.responsecode == 300 || res.data.responsecode == 400) {
          await this.$swal.fire({
            title: '<div style="color:background: rgba(12, 47, 83, 1);"> เกิดข้อผิดพลาด </div>',
            html: `<div> ${res.data.reason} </div>`,
            showCancelButton: false,
            showCloseButton: true,
            confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
            width: '590px'
          })
        }

      if (res.data.responsecode == 200) {
          await this.$swal.fire({
            title: '<div style="color:background: rgba(12, 47, 83, 1);"> สำเร็จ </div>',
            html: `<div>ยืนยันตัวตนสำเร็จ</div>`,
            showCancelButton: false,
            showCloseButton: true,
            confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
            width: '590px'
          })
          this.modalVerifyMember = false
          this.valueIndividual = {
        name: "",
        surname: "",
        birthdayRadio: "มีวันเดือนปีเกิดครบถ้วน",
        dob:"",
        id_card: "",
        laser_no: "",
        document:"",
        institute_name:"",
        coordinator_name:"",
        faculty:"",
        faculty_id:"",
      }
      location.reload()
      }
      if (res.responsecode == 200) {
          await this.$swal.fire({
            title: '<div style="color:background: rgba(12, 47, 83, 1);"> สำเร็จ </div>',
            html: `<div>ยืนยันตัวตนสำเร็จ</div>`,
            showCancelButton: false,
            showCloseButton: true,
            confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
            width: '590px'
          })
          this.modalVerifyMember = false
          this.valueIndividual = {
        name: "",
        surname: "",
        birthdayRadio: "มีวันเดือนปีเกิดครบถ้วน",
        dob:"",
        id_card: "",
        laser_no: "",
        document:"",
        institute_name:"",
        coordinator_name:"",
        faculty:"",
        faculty_id:"",
      }
      location.reload()
    }

     }catch(e){
      await this.$swal.fire({
        title: '<div style="color:background: rgba(12, 47, 83, 1);"> ข้อมูลไม่ถูกต้อง </div>',
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
        width: '590px'
      })
      location.reload()
      console.error(e)
     }
    },
    closeVerifyMember(){
      this.modalVerifyMemberType = true
      this.modalVerifyMember = false
      this.valueIndividual = {
        name: "",
        surname: "",
        birthdayRadio: "มีวันเดือนปีเกิดครบถ้วน",
        dob:"",
        id_card: "",
        laser_no: "",
        document:"",
        institute_name:"",
        coordinator_name:"",
        faculty:"",
        faculty_id:"",
      }
    },



    async depamemberlog(memberID) {
      // this.loading = true
      try {
        var params = {
          limit: this.limitCom,
          offset: this.offsetCom,
        }
        this.data = await api.depamemberlogs(memberID, params)

        this.depamemberlogs = this.data.data
        this.loading = false
      } catch (error) {
        console.error(error)
      }
    },
    async statusPaymentEdit(id, item) {
      console.log('@click.stop=""')
      this.$swal
        .fire({
          title: '<div class="headline primary--text bold7 fs-24">เปลี่ยนสถานะการจ่ายเงิน</div>',
          html: `<div class="primary--text fs-16">คุณแน่ใจหรือไม่ว่าต้องการเปลี่ยนสถานะเป็น</div><div class="primary--text fs-16">“${item}”</div>`,
          showCancelButton: true,
          showCloseButton: true,
        })
        .then(async (result) => {
          if (result.value) {
            let res = await api.memberInfoChangePayment(id, item)
            if (res.status === 200) {
              await this.getdepamemberinfoall()

              this.$swal.fire({
                type: 'success',
                title: '<div class="headline primary--text bold7 fs-24">ทำรายการสำเร็จ</div>',
                text: `${moment(new Date()).format('DD/MM/YY') + ' ' + moment(new Date()).format('HH:mm')
                  }`,
                confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
              })
            }
          }
        })
    },
    async checkPaymentTransaction(id) {
      let res = await api.postPaymentSlipData(id)
      this.slipData = res.data.data
      this.showPayment = true
    },
    async deleteMember(val) {
      let { memberid } = val
      this.$swal
        .fire({
          title:
            '<div class="headline primary--text bold7 fs-24">ยืนยันการยกเลิกการสมัครหรือไม่</div>',
          html: '<div class="primary--text fs-16">*หากยืนยันข้อมูลสมาชิกจะถูกลบออกและไม่สามารถกู้คืนได้</div>',
          showCancelButton: true,
          showCloseButton: true,
        })
        .then(async (result) => {
          if (result.value) {
            let res = await api.deletemember(memberid)
            if (res) {
              await this.getdepamemberinfoall()
              this.$swal.fire({
                title: '<div class="headline primary--text bold7 fs-24">ยกเลิกสมาชิกสำเร็จ</div>',
                showCancelButton: false,
                showCloseButton: true,
              })
            } else {
              this.$swal.fire('ยกเลิกสมาชิกไม่สำเร็จ')
            }
          }
        })
    },
    async depafirstAllowMember() {
      let resData = await api.depafirstAllowMember()
      this.firstUserId = resData ? resData : []
    },
    async changepage(pages) {
      this.page = parseInt(pages)
      this.numberPage.page = undefined
      this.loading = true
      await this.getdepamemberinfoall()
      this.loading = false
    },
    async exportData() {
      this.loading = true
      await this.getExData()
      this.$refs.exbtn.exportxlsx()
      this.modalExport = false
      this.loading = false
    },
    filteredName(item) {
      if (item.name) {
        return item.name
      } else if (item.coordinator_name) {
        return item.coordinator_name
      } else if (item.institute_name) {
        return item.institute_name
      }
    },
    async showOdooInfo(odooItem, memberid) {
      // let resOdoo = await api.getOdooData('SP-00001')
      // resOdoo = resOdoo.data
      // console.log(resOdoo)
      // let data = []
      // if (resOdoo) {
      //   data.push(JSON.parse(resOdoo))
      // }
      // this.currentOdoo = data
      // this.modalOdoo = true

      // this.loading = true
      const id = parseInt(memberid)
      let res = await api.getProjectByMemberid(id)
      if (res) {
        let idList = res.map((x) => {
          if (x.depaprojectid) {
            return x.depaprojectid
          }
        })
        if (idList && idList.length) {
          let data = []
          idList.forEach(async (id) => {
            let resOdoo = await api.getOdooData(id)
            resOdoo = resOdoo.data
            if (resOdoo) {
              data.push(JSON.parse(resOdoo))
            }
          })
          this.currentOdoo = data
        } else {
          this.currentOdoo = []
        }
        this.loading = false
        this.modalOdoo = true
      }
    },
    addTag(newTag, k) {
      const tag = newTag
      this.tagOptions.push(tag)

      this.search.tags.push(tag)
      this.update_tags.push(tag)
    },
    nametype(data) {
      return data.type
    },
    getdepamembertypeall() {
      api.getdepamembertypeall({ pageid: this.selectedBot.pageid }, (err, response) => {
        if (response.responsecode == 200) {
          this.membertype = response.data
          this.$store.state.depamembertype = response.data
        }
      })
    },
    rejectMember(item) {
      this.$swal
        .fire({
          title: '<div class="headline primary--text bold7 fs-24">ปฏิเสธ</div>',
          html: '<div class="primary--text fs-16">คุณแน่ใจหรือไม่ว่าต้องการปฏิเสธการยืนยันตัวตนนี้</div>',
          showCancelButton: true,
          showCloseButton: true,
        })
        .then((result) => {
          if (result.value) {
            api.depaadminrejectmemberregister({ memberid: item.memberid }, (err, response) => {
              this.getdepamemberinfoall()
              this.$swal.fire({
                type: 'success',
                title: '<div class="headline primary--text bold7 fs-24">ทำรายการสำเร็จ</div>',
                text: `${moment(new Date()).format('DD/MM/YY') + ' ' + moment(new Date()).format('HH:mm')
                  }`,
                confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
              })
            })
          }
        })
    },
    verifyMember(item) {
      this.$swal
        .fire({
          title: '<div class="headline primary--text bold7 fs-24">ยืนยันตัวตน</div>',
          html: '<div class="primary--text fs-16">คุณแน่ใจหรือไม่ว่าต้องการยืนยันตัวตนรายการนี้</div>',
          showCancelButton: true,
          showCloseButton: true,
        })
        .then((result) => {
          if (result.value) {
            api.depaUpdateStatusMemberRejectToConfirm(
              { memberid: item.memberid },
              (err, response) => {
                this.getdepamemberinfoall()
                this.$swal.fire({
                  type: 'success',
                  title: '<div class="headline primary--text bold7 fs-24">ทำรายการสำเร็จ</div>',
                  text: `${moment(new Date()).format('DD/MM/YY') + ' ' + moment(new Date()).format('HH:mm')
                    }`,
                  confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
                })
              }
            )
          }
        })
    },
    verifySME(item) {
      this.$swal
        .fire({
          title: '<div class="headline primary--text bold7 fs-24">ตรวจสอบข้อมูล SME ONE ID</div>',
          html: '<div class="primary--text fs-16">คุณแน่ใจหรือไม่ว่าต้องการตรวจสอบรายการนี้</div>',
          showCancelButton: true,
          showCloseButton: true,
        })
        .then((result) => {
          if (result.value) {
            api.depaUpdateStatusSME(
              { memberid: item.memberid,
                id_card: item.id_card,
               },
              (err, response) => {
                if (response.responsecode == 200){
                  this.getdepamemberinfoall()
                  this.$swal.fire({
                    type: 'success',
                    title: '<div class="headline primary--text bold7 fs-24">ทำรายการสำเร็จ</div>',
                    text: `${moment(new Date()).format('DD/MM/YY') + ' ' + moment(new Date()).format('HH:mm')
                      }`,
                    confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
                  })

                }
                this.loading = false
                
              }
            )
          }
        })
    },
    statusDPEdit(item) {
      this.modalStatusDP = true
      this.modalStatusDPEdit = item
      this.statusDP = item.dptype
    },
    async store(value) {
      let resCode = await api.sendmailforgetpassword(value)
      if (resCode == 204) {
        this.loading = false
        await this.$swal.fire({
          type: 'success',
          title: 'ส่งลิงค์สำหรับรีเซ็ตพาสเวิร์ดเรียบร้อย',
          icon: 'success',
          confirmButtonText: 'ปิด',
        })
        // this.$store.dispatch('logout', null).then()
        // this.$router.push('/' + this.currentLang + '/nigol')
      } else {
        this.loading = false
        this.$swal.fire({
          type: 'warning',
          title: 'ส่งอีเมลไม่สำเร็จ',
          text: 'เนื่องจาก ไม่มีข้อมูลสมาชิกนี้ในระบบ',
          icon: 'warning',
          confirmButtonText: 'ปิด',
        })
      }
    },
    async editStatusDP() {
      try {
        await this.$store.dispatch('depamemberinfo', {
          ...this.modalStatusDPEdit,
          dptype: this.statusDP,
        })
        this.getdepamemberinfoall()
        this.modalStatusDP = false
        this.$swal.fire({
          type: 'success',
          title: '<div class="headline primary--text bold7 fs-24">ทำรายการสำเร็จ</div>',
          text: `${moment(new Date()).format('DD/MM/YY') + ' ' + moment(new Date()).format('HH:mm')
            }`,
          confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
        })
      } catch (error) { }
    },
    changeSearchColumn(name) {
      let outputResult
      if (name.target._value !== '') {
        outputResult = this.columnAll.filter((item) => {
          return item.toLowerCase().indexOf(name.target._value.toLowerCase()) !== -1
        })
      } else {
        outputResult = this.columnAll.filter((item) => {
          return item
        })
      }
      this.column = outputResult
    },
    async sortPage(pages) {
      let count = Math.ceil(this.dessertsTotal / this.rowsPerPage)
      if (pages == '' || Number(pages <= 0) || pages > Number(count)) return
      if (pages) {
        this.page = parseInt(pages)
        this.loading = true
        await this.getdepamemberinfoall()
        this.loading = false
      }
    },
    clearSearchColumn() {
      this.searchColumn = ''
      this.column = this.columnAll
    },
    clickShowColumn(item) {
      if (this.showColumn.includes(item)) {
        var filterCheckbox = this.showColumn.filter((result) => result !== item)
        this.showColumn = filterCheckbox
      } else {
        this.showColumn.push(item)
      }
    },
    async clearSearch() {
      this.clearAdvancedSearch = false
      this.search = {
        name: '',
        institute_name: '',
        memberid: '',
        email: '',
        id_card: '',
        phone_number: '',
        status: '',
        type: '',
        dptype: '',
        tags: [],
      }

      this.isSearch = false
      this.loading = true
      this.searchloading = true
      this.page = 1
      await this.getdepamemberinfoall()
      this.searchloading = false
      this.showSearch = false
      this.loading = false
    },
    async onSearch() {
      this.isSearch = true
      this.loading = true
      this.searchloading = true
      this.page = 1
      await this.getdepamemberinfoall()
      this.searchloading = false
      this.showSearch = false
      this.loading = false
    },
    statusColor(item) {
      if (item == 'confirm') {
        return '#67AD5B'
      } else if (item == 'unconfirmed') {
        return '#818181'
      } else if (item == 'rejected') {
        return '#F10606'
      } else if (item == 'pending') {
        return '#FF8A00'
      } else return item
    },
    statusLabel(item) {
      if (item == 'confirm') {
        return 'ตรวจสอบแล้ว' // 'Verified'
      } else if (item == 'unconfirmed') {
        return 'ยังไม่ตรวจสอบ' //'Waiting'
      } else if (item == 'rejected') {
        return 'ปฏิเสธการยืนยันตัวตน' //'Rejected'
      } else if (item == 'pending') {
        return 'รออนุมัติ' // 'Pending'
      } else return item
    },
    statusSME(item) {
      if (item == true) {
        return 'ลงทะเบียนแล้ว' // 'Verified'
      } else if (item == false) {
        return 'ยังไม่ได้ลงทะเบียน' //'Waiting'
      } else return 'ตรวจสอบข้อมูล'
    },
    getdepamemberinfoall() {
      return new Promise((resolve) => {
        var search = {}
        var countSearch = 0
        for (const [key, value] of Object.entries(this.search)) {
          if (key == 'agencyname' && typeof value == 'object') {
            Object.assign(search, { ['agencyid']: value.id })
          } else if (value) {
            Object.assign(search, { [key]: value })
          }
          if (value && key != 'tags') {
            countSearch++
          }
        }

        // clear search advanced
        if (countSearch > 0 || search.tags.length > 0) {
          this.clearAdvancedSearch = true
        } else {
          this.clearAdvancedSearch = false
        }

        api.getdepamemberinfoall(
          {
            pageid: this.selectedBot.pageid,
            ...search,
            limit: this.limitCom,
            offset: this.offsetCom,
          },
          (err, response) => {
            this.desserts = response.data
            this.dessertsTotal = response.total
            resolve()
          }
        )
      })
    },
    getExData() {
      return new Promise((resolve) => {
        var search = {}
        for (const [key, value] of Object.entries(this.search)) {
          if (value) {
            Object.assign(search, { [key]: value })
          }
          // console.log(`${key}: ${value}`);
        }

        api.getdepamemberinfoall(
          {
            isexport: true,
            pageid: this.selectedBot.pageid,
            ...search,
          },
          (err, response) => {
            this.exdata = response.data
            resolve()
          }
        )
      })
    },
    async saveedit(item) {
      var index = this.desserts.findIndex((el) => el.memberid == item.memberid)
      this.$set(this.desserts, index, item)

      this.$swal.fire({
        type: 'success',
        title: '<div class="headline primary--text bold7 fs-24">ทำรายการสำเร็จ</div>',
        text: `${moment(new Date()).format('DD/MM/YY') + ' ' + moment(new Date()).format('HH:mm')}`,
        confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
      })

      this.editModal = false
    },
    closemodal() {
      this.editModal = false
      this.searchModal = false
    },
    async showEdit(item) {
      this.inputEdit = item
      await this.$nextTick()
      this.editModal = true
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    closeModalMember() {
      this.modalAddMember = false
    }
  },
}
</script>

<style lang="scss" scoped>
.amountDetail {
  background-color: #eaf1ff;
  height: 50px;
  width: 100%;
  border-radius: 10px;
  display: flex;
  align-items: baseline;
  justify-content: end;
  padding: 5px 10px;
}

.v-input {
  padding: 0;
  margin: 0;
}

.text-red {
  color: red;
}

.text-error {
  color: red;
}

.fixTable table.v-table {
  thead {
    tr {
      th:last-child {
        position: sticky !important;
        position: -webkit-sticky !important;
        right: 0;
        filter: drop-shadow(0px 2px 5px #d9d9d9);
      }

      th:last-child::after {
        content: '';
        border-left: 0;
      }
    }
  }

  tbody {
    tr {
      td:last-child {
        position: sticky !important;
        position: -webkit-sticky !important;
        background: #ffffff;
        right: 0;
        filter: drop-shadow(0px 2px 5px #d9d9d9);
      }

      td:last-child::after {
        content: '';
        border-left: 0;
      }
    }
  }
}


.button-select {
  background: #ffffff;
  //border: 1px solid #2c2c2c !important;
  border-radius: 6px !important;
  /* height: 38px; */
  outline: none;
  padding-top: 0px !important;
  margin-top: 0px !important;
}
.v-select.v-text-field--enclosed:not(.v-text-field--single-line) .v-select__selections {
  padding-top: 0px !important;
}
.date-picker-style {
  border: 1px solid #2c2c2c;
  border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/memberInfo/main.vue